import { rootActions } from '@store/slices'
import { LoggedinUserSupportPayload } from '@store/slices/support/loggedInUserSupport'
import axios from '@utils/request'
import { Action } from 'redux'
import { put, takeLatest } from 'redux-saga/effects'

interface TaskAction extends Action {
    payload: LoggedinUserSupportPayload
}

const { onRequest, onSuccess, onFailure } = rootActions.support.loggedinUserSupport

function* LoggedinUserSupportSagaTask({ payload }) {
    try {
        const response = yield axios.post(`/companies/support/ticket`, payload)
        if (response.success) {
            yield put(onSuccess(response.result))
            yield payload?.sagaCB.onSuccess()
        }
    } catch (error) {
        yield put(onFailure(error))
        yield payload?.sagaCB.onError()
    }
}

function* loggedinUserSupportSaga(): any {
    yield takeLatest<TaskAction>(onRequest, LoggedinUserSupportSagaTask)
}

export default loggedinUserSupportSaga
